import { highlightCoordinates } from '../commonActivities'

let lessonConfig = [
  {
    id: 0,
    previous: null,
    next: 2,
    video: {
      src: 'img/videos/lesson_3/1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 1
    }
  },
  {
    id: 1,
    previous: 0,
    next: 2,
    // text: {
    //   data: 'Here is a hint, there are six possible moves.',
    //   position: 'left',
    //   styleClass: 'md'
    // },
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on every <br/>square the White <br/>b and c pawns <br/>could move, <br/>and every square <br/>the black <br/>e and f pawns <br/>could move.`,
      timeout: 11000
    },
    audio: { src: 'img/audio/lesson_3/1.mp3', start: true, controls: false },
    chessboard: {
      board: highlightCoordinates({
        showIndicators: { allSides: true },
        position: { b2: 'wP', c3: 'wP', e6: 'bP', f7: 'bP' },
        coordinates: ['.square-b3', '.square-b4', '.square-c4', '.square-e5', '.square-f5', '.square-f6'],
        coordinateClass: 'filled-square',
        bubbleConfig: {
          data: `Nice job userName!`,
          position: 'left',
          styleClass: 'xs'
        },
        reminder: true,
        next: 2
      })
    }
  },
  {
    id: 2,
    previous: 0,
    next: 7,
    video: {
      src: 'img/videos/lesson_3/2.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 3,
    }
  },
  {
    id: 3,
    previous: 2,
    next: 7,
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on every <br/>piece both <br/>the White or <br/>Black pawns <br/>could capture.`,
      timeout: 8000
    },
    audio: { src: 'img/audio/lesson_3/2.mp3', start: true, controls: false },
    chessboard: {
      board: highlightCoordinates({
        showIndicators: { allSides: true },
        position: { a7: 'bP', b7: 'wN', c3: 'bN', d2: 'wP', d3: 'bB', g5: 'wP', g6: 'bP' },
        coordinates: ['.square-c3'],
        coordinateClass: 'filled-square',
        reminder: true,
        next: 4
      })
    }
  },
  {
    id: 4,
    previous: 3,
    next: 7,
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on every <br/>piece both <br/>the White or <br/>Black pawns <br/>could capture.`,
      timeout: 0
    },
    chessboard: {
      board: highlightCoordinates({
        showIndicators: { allSides: true },
        position: { b5: 'wP', c5: 'wP', c6: 'bP', d2: 'bB', d3: 'bB', d5: 'wN', d6: 'wB', e2: 'wP', h4: 'wN', h5: 'bP' },
        coordinates: ['.square-b5', '.square-c6', '.square-d3', '.square-d5'],
        coordinateClass: 'filled-square',
        reminder: true,
        next: 5
      })
    }
  },
  {
    id: 5,
    previous: 4,
    next: 7,
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on every <br/>piece both <br/>the White or <br/>Black pawns <br/>could capture.`,
      timeout: 0
    },
    chessboard: {
      board: highlightCoordinates({
        showIndicators: { allSides: true },
        position: { c4: 'wP', c5: 'bN', d4: 'wP', d5: 'bP', e5: 'wP', e6: 'bP', f6: 'bP', g6: 'wN' },
        coordinates: ['.square-c4', '.square-c5', '.square-d5', '.square-e5', '.square-f6'],
        coordinateClass: 'filled-square',
        next: 6,
        reminder: true
      })
    }
  },
  {
    id: 6,
    previous: 5,
    next: 7,
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on every <br/>piece both <br/>the White or <br/>Black pawns <br/>could capture.`,
      timeout: 0
    },
    chessboard: {
      board: highlightCoordinates({
        showIndicators: { allSides: true },
        position: { b3: 'wP', b4: 'wP', b5: 'bP', b6: 'wB', c3: 'bN', e4: 'wN', f4: 'wP', f5: 'bP', f6: 'bP', g5: 'wP', h4: 'bB' },
        coordinates: ['.square-e4', '.square-f6', '.square-g5'],
        coordinateClass: 'filled-square',
        next: 7,
        reminder: true
      })
    }
  },
  {
    id: 7,
    previous: 6,
    next: 8,
    video: {
      src: 'img/videos/lesson_3/3.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 8,
    }
  },
  {
    id: 8,
    previous: 7,
    next: 9,
    audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
    qa: {
      id: 0,
      question: 'How many pawns are on each team?',
      answer: [
        '1',
        '2',
        '4',
        '8'
      ],
      rightAnswer: '8',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 9,
    previous: 7,
    next: 10,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 1,
      question: 'How many points is the pawn worth?',
      answer: [
        '1',
        '2',
        '4',
        '8'
      ],
      rightAnswer: '1',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 10,
    previous: 7,
    next: 11,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 2,
      question: 'What is special about the pawn?',
      answer: [
        'It can move across the board in one turn',
        'It can be promoted to a Queen',
        'It can jump other pieces',
        'It can become a King'
      ],
      rightAnswer: 'It can be promoted to a Queen',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 11,
    previous: 7,
    next: 12,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 3,
      question: "What is the pawn's symbol?",
      answer: [
        '#',
        '3',
        '0',
        'p (or no symbol)'
      ],
      rightAnswer: 'p (or no symbol)',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 12,
    previous: 7,
    next: 13,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 4,
      question: 'In general, how does the pawn move?',
      answer: [
        'Side-to-side',
        'One square anywhere',
        'One square straight forward',
        'One square forward, one square to the side'
      ],
      rightAnswer: 'One square straight forward',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 13,
    previous: 7,
    next: 14,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 5,
      question: 'What can every pawn do on its first move only?',
      answer: [
        'Become a Queen',
        'Move forward two squares',
        'Move backward one square',
        'Capture another piece'
      ],
      rightAnswer: 'Move forward two squares',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  }, {
    id: 14,
    previous: 7,
    next: 15,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 6,
      question: 'Who does the pawn represent from the Middle Ages?',
      answer: [
        'A foot soldier',
        'A land owner',
        'A noble warrior',
        'A King'
      ],
      rightAnswer: 'A foot soldier',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 15,
    previous: 7,
    next: 16,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 7,
      question: 'Can a pawn move backwards?',
      answer: [
        'Yes, but only if he is under attack',
        'Yes, if he makes it across the board',
        'Sometimes',
        'No, never'
      ],
      rightAnswer: 'No, never',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 16,
    previous: 7,
    next: 17,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 8,
      question: 'How does a pawn capture?',
      answer: [
        'By jumping over the piece',
        'One square straight ahead',
        'One square on the diagonal',
        'One square behind him'
      ],
      rightAnswer: 'One square on the diagonal',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 17,
    previous: 7,
    next: 18,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 9,
      question: 'Where do pawns start the game?',
      answer: [
        'Filling the 1st and 8th ranks',
        'Filling the 2nd and 7th ranks',
        'Filling the a and h files',
        'Filling the d and e files'
      ],
      rightAnswer: 'Filling the 2nd and 7th ranks',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 18,
    previous: 7,
    next: null,
    audio: { src: null, stop: true },
    qa: {
      position: 'center',
      nextLesson: 'Lesson Four',
      result: true,
      styleClass: 'xl'
    }
  }
];

let assets = [
  '/img/background_2.png',
  '/img/background_3.png',
  '/img/background_4.png',
];

let config = {
  config: lessonConfig,
  assets: assets
};

export default config;


// WEBPACK FOOTER //
// ./src/lessons/lesson_3/index.js